export default [
  { label: 'Pago solicitado', value: 'pay_request' },
  { label: 'Pagado por Briiing', value: 'paid_by_briiing' },
  { label: 'Pagado por cliente', value: 'paid_by_client' }
];
